import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

// Import only used components
import {
  VApp,
  VAppBar,
  VAppBarTitle,
  VBtn,
  VBtnGroup,
  VCard,
  VCardText,
  VCardTitle,
  VChip,
  VContainer,
  VDialog,
  VDivider,
  VForm,
  VLayout,
  VList,
  VListItem,
  VListItemTitle,
  VMain,
  VMenu,
  VRow,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
  VCol
} from 'vuetify/components'

// Import only used directives
import { Ripple } from 'vuetify/directives'

import App from './App.vue'
import router from './router'
import './firebase.js'

const app = createApp(App)

// Components
const vuetify = createVuetify({
  components: {
    VApp,
    VAppBar,
    VAppBarTitle,
    VBtn,
    VBtnGroup,
    VCard,
    VCardText,
    VCardTitle,
    VChip,
    VContainer,
    VCol,
    VDialog,
    VDivider,
    VForm,
    VLayout,
    VList,
    VListItem,
    VListItemTitle,
    VMain,
    VMenu,
    VRow,
    VSpacer,
    VTextField,
    VToolbar,
    VToolbarTitle
  },
  directives: {
    Ripple
  },
  defaults: {
    VBtn: {
      elevation: 0,
      border: true,
      color: 'primary'
    },
    VSwitch: {
      color: 'primary'
    },
    VTextField: {
      color: 'primary',
      density: 'comfortable',
      variant: 'outlined'
    },
    VSelect: {
      color: 'primary',
      dense: true,
      variant: 'outlined'
    },
    VTextarea: {
      color: 'primary',
      dense: true,
      variant: 'outlined'
    },
    VRow: {
      dense: true
    },
    VDialog: {
      persistent: true,
      retainFocus: false
    }
  }
})

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
